import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService, ServiceRecord, ServiceGroupRecord } from '@core/services/data.service';
import { ModalService } from '@common/services/modal.service';

@Component({
  selector: 'app-service-editor',
  templateUrl: './service-editor.component.html',
  styleUrls: ['./service-editor.component.scss']
})
export class ServiceEditorComponent implements OnInit {

  @Input()
  public service: ServiceRecord;

  @Output()
  public change = new EventEmitter<ServiceRecord>();

  public groups: ServiceGroupRecord[] = [];

  constructor(private ds: DataService, private modal: ModalService) { }

  ngOnInit(): void {

    this.service = this.service ? { ... this.service } : { ID: 0, GroupID: 0, Name: '', Address: '' };
    this.ds.groups('list').subscribe(groups => this.groups = groups);
  }

  public close() {
    this.modal.of(this).hide();
  }

  public save() {
    if (this.service.GroupID > 0) {
      this.ds.services(this.service.ID > 0 ? 'update' : 'create', this.service).subscribe(services => {
        if (services && services.length == 1) {

          this.service = services[0];
          this.change.emit(this.service);
          this.modal.of(this).hide();
        }        
      });
    }
  }

}
